import deviceFingerprint from "../../../../shared/utilities/deviceFingerprint";

export default {
  get: deviceFingerprint
};
